// Mirror of backend MAX_UPLOAD_SIZE in shared/storage.py.
// Keep these in sync — server is the source of truth, client just gives early UX feedback.
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;

export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "image/bmp",
  "image/heic",
  "image/heif",
] as const;
export const ALLOWED_DOC_TYPES = [...ALLOWED_IMAGE_TYPES, "application/pdf"] as const;

// Convenience string for `<input type="file" accept={...} />`. Browsers only
// recognize the type list; on iPhones the user picks from the photo library
// regardless. HEIC files come over with content_type "image/heic" or
// occasionally an empty string — the server validates magic bytes either way.
export const IMAGE_ACCEPT_ATTR = ALLOWED_IMAGE_TYPES.join(",");
export const DOC_ACCEPT_ATTR = ALLOWED_DOC_TYPES.join(",");

type AllowedType = (typeof ALLOWED_DOC_TYPES)[number];

/**
 * Check a File before sending it to the server. Returns null when ok, or a
 * user-facing message when the upload should be rejected.
 */
export function validateUpload(
  file: File,
  allowed: readonly AllowedType[] = ALLOWED_DOC_TYPES,
): string | null {
  if (file.size > MAX_UPLOAD_BYTES) {
    return `File is ${(file.size / 1024 / 1024).toFixed(1)}MB. Max is 5MB.`;
  }
  if (!allowed.includes(file.type as AllowedType)) {
    return `Unsupported file type. Allowed: ${allowed.join(", ")}.`;
  }
  return null;
}
